import { AMOwnershipParcelComplete } from 'src/common-services'
import { MapSquareIcon } from 'src/components/icons/map-square'
import { Colors } from 'src/components/theme'
import { PARCEL_TYPES_BY_MCODE_MAP } from 'src/constants/cherre-data-dictionary/zoning-colors'
import { findPlace } from 'src/utils/google-places'
import { ParcelTypeChip } from 'src/v2/components/parcel-type-chip'
import { SidebarResultListItem } from 'src/v2/components/sidebar-result-list'
import { ParcelSummary } from 'src/v2/views/owner-reveal/sidebar/parcel-summary'
import { parcelFullAddress } from 'src/views/map-explorer/sidebar/panels/selected-parcel'
import { formatString } from 'src/utils/format-string'
export const convertParcelToSidebarItem = (parcel: AMOwnershipParcelComplete): SidebarResultListItem => {
  return {
    id: parcel.id,
    color: Colors.primaryGreen700,
    icon: <MapSquareIcon size={12} />,
    header: <ParcelTypeChip type={PARCEL_TYPES_BY_MCODE_MAP[parcel.mCode || '']} />,
    title: formatString(parcelFullAddress(parcel.address, parcel.city, parcel.state || '', parcel.zip), 'address'),
    subtitle: `APN # ${parcel.apn}`,
    footer: (
      <ParcelSummary
        amountOfContacts={parcel.owners.length}
        brandIds={parcel.brandedLocations.map((location) => location.brandId || '')}
      />
    ),
  }
}

export type BaseParcelForLink = Pick<AMOwnershipParcelComplete, 'address' | 'point'>
export const getParcelPropertyRecordsLink = async (parcel: BaseParcelForLink): Promise<string | undefined> => {
  if (!parcel || !parcel.address || !parcel.point) {
    return undefined
  }

  const place = await findPlace(parcel.address, parcel.point.geometry.coordinates)
  if (!place?.place_id) {
    return undefined
  }

  return `/insights/property-details?id.google=${place?.place_id}`
}

export const getParcelZoningLink = async (parcel: BaseParcelForLink): Promise<string | undefined> => {
  if (!parcel || !parcel.address || !parcel.point) {
    return undefined
  }

  const place = await findPlace(parcel.address, parcel.point.geometry.coordinates)
  if (!place?.place_id) {
    return undefined
  }

  return `/insights/zoning?id.google=${place?.place_id}`
}

type ParcelForLookup = Pick<AMOwnershipParcelComplete, 'address' | 'city' | 'state' | 'zip'>
export const lookupParcelInMapExplorer = (parcel: ParcelForLookup) => {
  if (!parcel || !parcel.address) {
    return undefined
  }

  const fullAddress = parcelFullAddress(parcel.address, parcel.city, parcel.state || '', parcel.zip)
  window.open(`/?lookup=${encodeURIComponent(fullAddress)}`, '_blank')
}
